import { render, staticRenderFns } from "./AdvanceItem.vue?vue&type=template&id=9b4fc49c&scoped=true&"
import script from "./AdvanceItem.vue?vue&type=script&lang=js&"
export * from "./AdvanceItem.vue?vue&type=script&lang=js&"
import style0 from "@styles/other/home/homeHotwords.css?vue&type=style&index=0&id=9b4fc49c&scoped=true&lang=css&"
import style1 from "./AdvanceItem.vue?vue&type=style&index=1&id=9b4fc49c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4fc49c",
  null
  
)

export default component.exports